<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('直播课程.教师姓名')">
                <a-input v-model="queryParam.teacherName" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['livecourse:liveTeacher:add']">
          <a-icon type="plus" />{{$t('通用.按钮.新增')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['livecourse:liveTeacher:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button>
      </div>
      <create-form ref="createForm" @ok="getList" />
      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="teacherAvatar" slot-scope="text, record">
          <img v-if="record.teacherAvatar" :src="record.teacherAvatar" style="width: 60px; height: 60px; object-fit: cover; border-radius: 50%;" />
        </span>
        <span slot="teacherGender" slot-scope="text, record">
          {{ getGenderText(record.teacherGender) }}
        </span>
        <span slot="teacherImages" slot-scope="text, record">
          <img v-for="(img, index) in getTeacherImages(record.teacherImages)" :key="index" :src="img" style="width: 40px; height: 40px; object-fit: cover; margin-right: 5px; border-radius: 4px;" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['livecourse:liveTeacher:edit']">
            <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['livecourse:liveTeacher:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageLiveTeacher, delLiveTeacher } from '@/api/livecourse/liveTeacher'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'LiveTeacher',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      total: 0,
      selectedRowKeys: [],
      multiple: true,
      queryParam: {
        teacherName: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: this.$t('直播课程.教师头像'), dataIndex: 'teacherAvatar', scopedSlots: { customRender: 'teacherAvatar' } },
        { title: this.$t('直播课程.教师姓名'), dataIndex: 'teacherName' },
        { title: this.$t('直播课程.教师年龄'), dataIndex: 'teacherAge' },
        { title: this.$t('直播课程.教师性别'), dataIndex: 'teacherGender', scopedSlots: { customRender: 'teacherGender' } },
        { title: this.$t('直播课程.教师风采'), dataIndex: 'teacherImages', scopedSlots: { customRender: 'teacherImages' } },
        { title: this.$t('直播课程.创建时间'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' } },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      pageLiveTeacher(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { pageNum: 1, pageSize: 10 }
      this.handleQuery()
    },
    handleDelete(row) {
      const that = this
      this.$confirm({
        title: this.$t('通用.文本.确认删除'),
        content: this.$t('通用.文本.删除确认数据'),
        onOk() {
          const ids = row.id || that.selectedRowKeys
          delLiveTeacher(ids).then(() => {
            that.getList()
            that.$message.success(that.$t('通用.文本.删除成功'))
          })
        }
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    getGenderText(gender) {
      if (gender === 1) return '男'
      if (gender === 2) return '女'
      return '未知'
    },
    getTeacherImages(images) {
      if (!images) return []
      if (Array.isArray(images)) return images
      try {
        return JSON.parse(images)
      } catch (e) {
        return []
      }
    }
  }
}
</script>
